import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { CircularProgress, IconButton } from "@mui/material";
import { AddReservationDialog } from "../../components/dialog/AddReservationDialog/AddReservationDialog";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";
import { useHasRole } from "../../hooks/auth/useCheckPermission";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useBookingById } from "../../services/bookingsService";
import { BookingManageDialog } from "./BookingManageDialog";
import { EXCLUDED_PRODUCT_STATUSES_FOR_NEW_BOOKING } from "./utils";

export const BookingManageButton = (props) => {
    const { bookingId, booking: bookingProp } = props;
    // Prefer booking prop to avoid additional API calls. Fall back to fetching by ID for backward compatibility
    const { data: fetchedBooking, isLoading } = useBookingById(bookingId, {
        enabled: !bookingProp && !!bookingId,
    });
    const booking = bookingProp || fetchedBooking;
    const { openDialog } = useDialogBetter();
    const { user } = useAuth();
    const hasCancelBookingPermission = useHasRole([USER_ROLES.ADMIN, USER_ROLES.SALES_MANAGER]);

    if (!booking || isLoading) {
        return <CircularProgress />;
    }

    const isActive = booking.status.status_name_eng === "Active";
    const isCreator = user?.full_name === booking.creator;
    const isDisabled = !hasCancelBookingPermission && isActive && !isCreator;

    const openManageBookingDialog = (booking) => {
        openDialog({
            Component: BookingManageDialog,
            componentProps: { booking },
        });
    };

    const openCreateBookingDialog = (booking) => {
        openDialog({
            Component: AddReservationDialog,
            componentProps: {
                initialCustomerIds: booking.customers.map((c) => c.customer.id),
                initialProductIds: booking.products
                    .filter(
                        (p) =>
                            !EXCLUDED_PRODUCT_STATUSES_FOR_NEW_BOOKING.includes(
                                p.status.status_key,
                            ),
                    )
                    .map((p) => p.id),
                initialDiscounts:  booking?.offer?.products.reduce((discounts, offerProduct) => ({ ...discounts, [offerProduct.product?.id]: offerProduct.discount_percent}), {}) 
            },
        });
    };
    return (
        <IconButton
            color="primary"
            disabled={isDisabled}
            onClick={() =>
                isActive ? openManageBookingDialog(booking) : openCreateBookingDialog(booking)
            }
        >
            {isActive ? <TuneOutlinedIcon /> : <UpdateOutlinedIcon />}
        </IconButton>
    );
};
